import React, { useState } from 'react';
import { MenuItem, Select, InputLabel, FormControl, Container, TextField, Button, Typography, Paper, InputAdornment, IconButton } from '@mui/material';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
import backgroundImage from '../assets/background.jpg'; 
import { signup } from './api'; 
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FlagIcon from '../assets/pakistan-flag.png'; // Replace with actual path to Pakistan flag icon

const theme = createTheme({
  spacing: 8,
});

const Root = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  backgroundImage: `url(${backgroundImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(2),
}));

const FormContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  maxWidth: '500px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  '& .MuiTextField-root': {
    width: '100%',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
  },
}));

const PhoneInputAdornment = (
  <InputAdornment position="start">
    <IconButton size="small" edge="start">
      <img src={FlagIcon} alt="Pakistan Flag" style={{ width: 20, height: 15 }} />
    </IconButton>
    +92
  </InputAdornment>
);

const SignupPage = () => {
  const [username, setUsername] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [occupation, setOccupation] = useState('');
  const [designation, setDesignation] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [nationality1, setNationality1] = useState('');
  const [nationality2, setNationality2] = useState('');
  const [relationship, setRelationShip] = useState('');
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!username || !phoneNumber || !email || !password || !confirmPassword || !occupation || !designation || !organisation || !nationality1) {
      toast.error("All fields are required!");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Invalid email format!");
      return;
    }

    // Validate password match
    if (password !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    // Ensure phone number has the +92 prefix
    const formattedPhoneNumber = phoneNumber.startsWith('+92') ? phoneNumber : `+92${phoneNumber}`;

    // Call signup API if all validations pass
    try {
      const data = {
        username,
        relationship,
        phone_number: formattedPhoneNumber,
        email,
        password,
        confirm_password: confirmPassword,
        occupation,
        designation,
        organisation,
        nationality_1: nationality1,
        nationality_2: nationality2,
      };
      await signup(data);
      toast.success("Signup successful!");
      setTimeout(() => {
        navigate(`/login`);
      }, 1000); // Wait for the toast to close (1 second)
    } catch (error) {
      toast.error("Signup failed!");
      console.error("Error during signup:", error);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Root>
        <ToastContainer />
        <Container maxWidth="sm">
          <FormContainer>
            <Typography variant="h4" component="h1" gutterBottom>
              Sign Up
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              Parent signup to register their children.
            </Typography>
            <StyledForm onSubmit={handleSignup}>
              <TextField
                label="Username"
                variant="outlined"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />

              <FormControl fullWidth margin="normal">
                <InputLabel id="relationship-label">Relationship</InputLabel>
                <Select
                  labelId="relationship-label"
                  id="relationship"
                  name="relationship"
                  value={relationship}
                  label="Relationship"
                  onChange={(e) => setRelationShip(e.target.value)}
                >
                  <MenuItem value="Mother">Mother</MenuItem>
                  <MenuItem value="Father">Father</MenuItem>
                  <MenuItem value="Guardian">Guardian</MenuItem>
                </Select>
              </FormControl>
<br/>
              <TextField
                label="Phone Number"
                variant="outlined"
                fullWidth
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                InputProps={{
                  startAdornment: PhoneInputAdornment,
                }}
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                label="Password"
                type="password"
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <TextField
                label="Confirm Password"
                type="password"
                variant="outlined"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <TextField
                label="Occupation"
                variant="outlined"
                fullWidth
                value={occupation}
                onChange={(e) => setOccupation(e.target.value)}
              />
              <TextField
                label="Designation"
                variant="outlined"
                fullWidth
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
              />
              <TextField
                label="Organisation"
                variant="outlined"
                fullWidth
                value={organisation}
                onChange={(e) => setOrganisation(e.target.value)}
              />
              <TextField
                label="Nationality 1"
                variant="outlined"
                fullWidth
                value={nationality1}
                onChange={(e) => setNationality1(e.target.value)}
              />
              <TextField
                label="Nationality 2"
                variant="outlined"
                fullWidth
                value={nationality2}
                onChange={(e) => setNationality2(e.target.value)}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ marginTop: 2 }}
              >
                Sign Up
              </Button>
            </StyledForm>
            <Typography variant="body2" sx={{ marginTop: 2 }}>
              Already have an account? <Link to="/login">login</Link>
            </Typography>
          </FormContainer>
        </Container>
      </Root>
    </ThemeProvider>
  );
};

export default SignupPage;
